import { segmentModule } from '@/plugins/segment/SegmentModule'

const getNameForPage = ({ meta = {}, name }) => meta.segmentName || name

export const trackPage = (to, from) => {
  if (to && from !== undefined && from.name !== undefined) {
    segmentModule.page(getNameForPage(to), { referrer: getNameForPage(from) })
  }
}
